import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getDisplayValue'
})
export class GetDisplayValuePipe implements PipeTransform {

  transform(data: any, field: string): unknown {
    return data?.record?.[field]?.displayValue || data?.record?.['C_' + field]?.displayValue;
  }

}
